<div style="display: flex;" [style.padding]="padding">
    <div style="border-style: solid; border-width: 2px; background-color: var(--grey6); border-radius: 4px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;"
        [style.height]="checkboxSize" [style.width]="checkboxSize"
        [style.border-color]="value ? 'var(--main1)':'var(--grey5)'"
        [style.background-color]="value ? 'var(--white)':'var(--grey6)'" mat-ripple (click)="handleValueChange()">
        <span class="material-symbols-outlined text-main1" *ngIf="value">
            done
        </span>
    </div>
    <div style="width: 100%;">
        <div mat-ripple (click)="handleValueChange()" [style.padding-left]="textPaddingLeft">
            <div style="font-weight: 500; margin: 0px; padding: 0px; margin-bottom: 5px;" class="text-grey3"
                [style.font-size]="titleFontSize" *ngIf="title" [style.padding-top]="titlePaddingtop">{{ title }}</div>
            <div [style.font-size]="subtitleFontSize" class="text-grey4" *ngIf="subtitle">{{ subtitle }}</div>
        </div>
        <div style="margin-top: 12px;" [style.padding-left]="textPaddingLeft">
            <ng-content></ng-content>
        </div>
    </div>
</div>